<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/blue-code.jpg')" >
      </parallax>
      <div class="content-center">
        <div class="container">
          <img class="n-logo" src="img/stormhaven-logo.small.png" alt="" />
          <h1 class="title">Senior Generalist Programmer</h1>
        </div>
      </div>
    </div>
    <div class="section">
        <div class="container">
            <div class="row">
                <p>As a Senior Generalist Programmer on the Embers Adrift MMORPG, you will work closely with our lead programmers, artists, designers, and producers to implement and optimize game features.</p>
                <p style="font-weight: bold;">This is a full-time, salaried position.</p>
                <p>While we are an Austin, Texas company, we fully support a remote work force and encourage talented individuals from anywhere in the world to apply. We are an equal opportunity employer.</p>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Your Background and Experience</div>
            </div>
            <div class="row">
                <ul>
                    <li>5+ years game industry C# development programming experience with at least 2+ years of engine experience</li>
                    <li>Bachelor’s degree in Computer Science, Software Engineering or equivalent experience</li>
                    <li>Very strong C# design and coding experience</li>
                    <li>Experience in building multithreaded, real-time systems</li>
                    <li>Experience writing systems balancing performance and maintainability</li>
                    <li>Excellent analytical and mathematical skills</li>
                    <li>Strong interpersonal skills and problem solving ability</li>
                    <li>Experience profiling and optimizing both CPU and GPU utilization</li>
                    <li>Experience with game editor plugins/modification</li>
                    <li>Experience with animation, 3D graphics, audio, AI, or gameplay programming a plus</li>
                    <li>Ability to contribute innovative and original ideas towards all aspects of game production and development</li>
                    <li>Strong communication and organizational skills</li>
                    <li>Must work well under pressure and handle multiple tasks</li>
                    <li>Passion for making GREAT games</li>
                    <li>Experience playing previous group-based MMORPGs</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Day to Day Tasks</div>
            </div>
            <div class="row">
                <ul>
                    <li>Writes clear, maintainable, highly functional code and portable C# code</li>
                    <li>Plans and designs code in collaboration with team members</li>
                    <li>Enjoys jumping into lots of different systems, tackling everything from entire systems to random tasks</li>
                    <li>Supports and maintains existing systems</li>
                    <li>Must be a self-motivated and energetic team player with a very strong work ethic and cooperative attitude</li>
                    <li>Accurately estimates his/her schedules and delivers high quality work products to that schedule</li>
                    <li>Provide technical expertise to develop cutting-edge technologies to include: architecture, design, prototype, implement, test, debug, document, profile, maintain, and support</li>
                    <li>Review codes from other team members</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Pluses</div>
            </div>
            <div class="row">
                <ul>
                    <li>Development experience on the Unity engine</li>
                    <li>C++ design and coding experience</li>
                    <li>Unreal/Hero/other engine experience</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Requirements for Applying</div>
            </div>
            <div class="row">
                <ul>
                    <li>Resume</li>
                    <li>Cover letter which should include:
                        <ul>
                            <li>Why you are interested in working at Stormhaven Studios, LLC</li>
                            <li>What games you are currently playing</li>
                        </ul>
                    </li>
                    <li>Portfolio – Only digital applications will be accepted such as a website, blog, or online album.  Physical media will not be accepted.</li>
                    <li>A paid test may be requested during the interview process</li>
                </ul>
            </div>
            <div class="row">
                <p>Stormhaven Studios, LLC is a global company committed to growing our contractors and employees along with the business. We’ve worked hard to foster an intensely collaborative and creative environment with a diverse and inclusive culture of people from around the world, with training and opportunity for professional growth. Our people are everything to us. We are dedicated to creating the most epic entertainment experiences…ever. We look forward to having you on the team!</p>
            </div>
            <div class="row" style="margin-top: 24px;">
                <h2><a href="mailto:jobs@stormhavenstudios.com">Apply Now!</a></h2>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'seniorprogrammer',
  bodyClass: 'landing-page'
};
</script>
<style></style>
